import VTooltip from 'v-tooltip'
VTooltip.enabled = window.innerWidth > 767 && window.innerWidth < 1281

export default {
    methods: {
        getTooltipOptions(label) {
            return {
                content: label,
                placement: 'right',
                offset: '5'
            }
        }
    }
}
